import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyLang, getCurrentLang } from '../utils/i18n';
import './Asc.css';

const CAPITAINE = {
  num: "10",
  name: "Cheikh Diop",
  role: "Capitaine · Attaquant",
  age: "26 ans · 1m82",
  bio: "Formé sur la plage de Cambérène avant de rejoindre le centre de formation de Diambars. Recordman de buts du Navétane sur les trois dernières saisons — son pied droit est devenu une signature dans tout le Sénégal.",
  stats: [
    { val: "147", lbl: "Matchs" },
    { val: "92",  lbl: "Buts" },
    { val: "34",  lbl: "Passes D." },
  ],
  seed: "cb-asc-diop-portrait",
};

const SQUAD = [
  { num: "01", name: "Modou Sow",     pos: "Gardien",        age: "29 ans", seed: "cb-asc-keeper" },
  { num: "04", name: "Ibrahima Fall", pos: "Défenseur axial", age: "24 ans", seed: "cb-asc-def" },
  { num: "06", name: "Pape Ndiaye",   pos: "Milieu récup.",   age: "22 ans", seed: "cb-asc-mid" },
  { num: "07", name: "Lamine Ba",     pos: "Ailier gauche",   age: "20 ans", seed: "cb-asc-wing" },
];

const MATCHES = [
  { date: "12", month: "Mai",   home: "ASC Cambérène", away: "ASC Pikine",      time: "20h00", competition: "Navétane · 33ᵉ J", venue: "HOME",  status: "home" },
  { date: "19", month: "Mai",   home: "ASC Hann",      away: "ASC Cambérène",   time: "17h30", competition: "Navétane · 34ᵉ J", venue: "AWAY",  status: "away" },
  { date: "26", month: "Mai",   home: "ASC Cambérène", away: "Finale régionale",time: "21h00", competition: "Finale Région",   venue: "FINAL", status: "final" },
  { date: "02", month: "Juin",  home: "Vainqueur DKR", away: "ASC Cambérène",   time: "20h00", competition: "Demi · National",  venue: "AWAY",  status: "away" },
];

const STANDINGS = [
  { rk: 1, name: "ASC Yoff",       mark: "YF", j: 32, gd: "+34", pts: 68, us: false },
  { rk: 2, name: "ASC Cambérène",  mark: "CB", j: 32, gd: "+28", pts: 64, us: true },
  { rk: 3, name: "ASC Pikine",     mark: "PK", j: 32, gd: "+22", pts: 59, us: false },
  { rk: 4, name: "ASC Hann",       mark: "HN", j: 32, gd: "+18", pts: 54, us: false },
  { rk: 5, name: "ASC Médina",     mark: "MD", j: 32, gd: "+12", pts: 48, us: false },
];

const STADE = {
  name: "Stade municipal de Cambérène",
  addr: "Côte Nord, à 200m de la plage. Le terrain de sable historique où sont formées les générations de l'ASC depuis 1986.",
  info: [
    { lbl: "Capacité",    val: "2 400 places" },
    { lbl: "Surface",     val: "Sable damé" },
    { lbl: "Tribune",     val: "1 tribune couverte" },
    { lbl: "Accès",       val: "Gratuit · Match week-end" },
  ],
  seed: "cb-asc-stade-jour",
};

const PALMARES = [
  { year: "1986", title: "Création de l'ASC Cambérène",            trophy: "Fondation", gold: false },
  { year: "1994", title: "Premier titre Navétane régional",         trophy: "Champion",  gold: true  },
  { year: "2001", title: "Demi-finale Coupe Nationale Quartier",    trophy: "Demi-finale", gold: false },
  { year: "2012", title: "Doublé Coupe + Championnat régional",     trophy: "Double",    gold: true  },
  { year: "2019", title: "Sacre national Navétane Sénégal",         trophy: "Champion National", gold: true  },
  { year: "2024", title: "Finale interrégionale Dakar",             trophy: "Finaliste", gold: false },
];

const Evenements = () => {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }),
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.asc-page .reveal').forEach((el) => io.observe(el));
    applyLang(getCurrentLang());
    return () => io.disconnect();
  }, []);

  return (
    <main className="asc-page">
      {/* ============== HERO ============== */}
      <header className="asc-hero">
        <div className="asc-hero-bg" />
        <div className="asc-hero-grain" />
        <div className="asc-hero-watermark" aria-hidden="true">ASC</div>

        <div className="asc-hero-meta">
          <div><b>1986</b><span>Année de fondation</span></div>
          <div><b>#2</b><span>Classement régional</span></div>
        </div>

        <div className="wrap asc-hero-inner reveal">
          <span className="asc-hero-eyebrow">ASC Cambérène · Saison 2026 · Navétane</span>
          <h1>
            Le sable<br />
            qui forme <b>les jambes.</b>
          </h1>
          <p className="lede">
            Quarante ans que l'ASC Cambérène façonne ses joueurs sur le terrain de sable face à
            l'océan. Le Navétane n'est pas qu'un tournoi de quartier — c'est l'école des pieds.
            Suivez la saison, les jeunes, les soirs de stade.
          </p>
          <div className="asc-hero-actions">
            <a className="btn btn-primary" href="#matches">
              <span>Prochains matchs</span>
              <span className="arrow">→</span>
            </a>
            <a className="btn btn-ghost" href="#palmares">
              <span>Voir le palmarès</span>
              <span className="arrow">↗</span>
            </a>
          </div>
        </div>
      </header>

      {/* ============== LIVE BAR ============== */}
      <div className="asc-live">
        <div className="wrap">
          <span className="dot" />
          <span className="label">En direct</span>
          <span className="score">ASC Cambérène <b>2 — 1</b> ASC Yoff</span>
          <span className="min">78ᵉ minute · Stade Iba Mar Diop</span>
        </div>
      </div>

      {/* ============== QUOTE ============== */}
      <section className="asc-quote reveal">
        <div className="wrap">
          <p>« Sur le sable, on apprend deux choses : à se relever vite, et à ne jamais arrêter de courir. »</p>
          <span className="src">Coach Mansour Ndiaye · 2024</span>
        </div>
      </section>

      {/* ============== CAPITAINE ============== */}
      <section className="asc-section asc-cap">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Capitaine</span>
              <h2>Le visage<br /><span className="ital">de la saison.</span></h2>
            </div>
            <p>
              Numéro 10, capitaine, recordman de buts — Cheikh Diop porte l'ASC sur ses épaules
              depuis trois saisons. Un attaquant formé ici, qui n'a jamais voulu partir.
            </p>
          </div>

          <div className="cap-grid">
            <div className="cap-photo reveal">
              <div className="img" style={{ backgroundImage: `url('https://picsum.photos/seed/${CAPITAINE.seed}/1200/1500')` }} />
              <div className="grad" />
              <span className="num">{CAPITAINE.num}</span>
              <div className="nm">
                <small>{CAPITAINE.role}</small>
                <h3>{CAPITAINE.name}</h3>
              </div>
            </div>

            <div className="cap-info reveal">
              <span className="role">{CAPITAINE.age}</span>
              <h4>{CAPITAINE.name}</h4>
              <p>{CAPITAINE.bio}</p>

              <div className="cap-stats">
                {CAPITAINE.stats.map((s) => (
                  <div key={s.lbl} className="cap-stat">
                    <b>{s.val}</b>
                    <small>{s.lbl}</small>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== EFFECTIF ============== */}
      <section className="asc-section asc-squad">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Effectif 2026</span>
              <h2>Quatre piliers<br /><span className="ital">de l'équipe.</span></h2>
            </div>
            <p>
              Une équipe jeune mais structurée — moyenne d'âge 23 ans, dont 9 joueurs
              formés au club. Voici quatre des cadres autour du capitaine.
            </p>
          </div>

          <div className="squad-grid">
            {SQUAD.map((p) => (
              <article key={p.num} className="squad-card reveal">
                <div className="ph">
                  <div className="img" style={{ backgroundImage: `url('https://picsum.photos/seed/${p.seed}/900/1100')` }} />
                  <span className="num">{p.num}</span>
                </div>
                <div className="body">
                  <small>{p.pos}</small>
                  <h5>{p.name}</h5>
                  <span className="age">{p.age}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ============== MATCHES (light section) ============== */}
      <section className="asc-section light" id="matches">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Calendrier</span>
              <h2>Prochaines<br /><span className="ital">rencontres.</span></h2>
            </div>
            <p>
              Les quatre prochains matchs de l'ASC Cambérène — domicile, extérieur, finale.
              Suivez les résultats en direct sur place ou en streaming.
            </p>
          </div>

          <div className="matches-list">
            {MATCHES.map((m, i) => (
              <div key={i} className="match-row reveal">
                <div className="date">
                  <b>{m.date}</b>
                  <small>{m.month}</small>
                </div>
                <div className="vs">
                  <h5>{m.home} <span style={{ opacity: .35 }}>—</span> {m.away}</h5>
                  <small>{m.time} · {m.venue === 'HOME' ? 'Domicile' : m.venue === 'AWAY' ? 'Extérieur' : 'Finale'}</small>
                </div>
                <div className="competition">{m.competition}</div>
                <div className={`badge ${m.status}`}>
                  {m.status === 'home'  && '⌖ HOME'}
                  {m.status === 'away'  && '→ AWAY'}
                  {m.status === 'final' && '★ FINAL'}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============== CLASSEMENT ============== */}
      <section className="asc-section asc-standings">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Classement régional</span>
              <h2>Deuxième,<br /><span className="ital">à 4 points.</span></h2>
            </div>
            <p>
              L'ASC Cambérène pointe à la deuxième place de la zone Dakar Nord, à quatre points
              du leader. Encore deux journées pour rattraper Yoff.
            </p>
          </div>

          <div className="stand-shell">
            <div className="stand-table reveal">
              <div className="stand-row head">
                <span>#</span>
                <span>Équipe</span>
                <span style={{ textAlign: 'right' }}>J</span>
                <span style={{ textAlign: 'right' }}>+/-</span>
                <span style={{ textAlign: 'right' }}>Pts</span>
              </div>
              {STANDINGS.map((s) => (
                <div key={s.rk} className={`stand-row${s.us ? ' us' : ''}`}>
                  <span className="rk">{String(s.rk).padStart(2, '0')}</span>
                  <span className="name">
                    <span className="mark">{s.mark}</span>
                    {s.name}
                  </span>
                  <span className="num">{s.j}</span>
                  <span className="num">{s.gd}</span>
                  <span className="pts">{s.pts}</span>
                </div>
              ))}
            </div>

            <div className="stand-side reveal">
              <div className="stand-pill">
                <small>Forme — 5 derniers</small>
                <div className="form">
                  <span className="w">G</span>
                  <span className="w">G</span>
                  <span className="d">N</span>
                  <span className="w">G</span>
                  <span className="l">P</span>
                </div>
              </div>
              <div className="stand-pill">
                <small>Différence buts</small>
                <b>+28</b>
                <p><span className="arrow-up">↑</span> 2ᵉ meilleure attaque de la zone</p>
              </div>
              <div className="stand-pill">
                <small>Meilleur buteur</small>
                <b>Cheikh Diop · 28</b>
                <p>Recordman de la saison sur la zone Dakar Nord</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============== STADE ============== */}
      <section className="asc-section light">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Le terrain</span>
              <h2>Sable damé,<br /><span className="ital">face à l'océan.</span></h2>
            </div>
            <p>
              Le stade municipal de Cambérène est plus qu'un terrain — c'est le berceau
              du football local. Sable damé, tribune couverte, ambiance unique les soirs de match.
            </p>
          </div>

          <div className="stade-grid">
            <div className="stade-ph reveal">
              <div className="img" style={{ backgroundImage: `url('https://picsum.photos/seed/${STADE.seed}/1600/1200')` }} />
            </div>
            <div className="stade-info reveal">
              <h3>{STADE.name}</h3>
              <p className="addr">{STADE.addr}</p>
              <ul>
                {STADE.info.map((i) => (
                  <li key={i.lbl}>
                    <small>{i.lbl}</small>
                    <b>{i.val}</b>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ============== PALMARÈS ============== */}
      <section className="asc-section asc-palm" id="palmares">
        <div className="wrap">
          <div className="asc-head reveal">
            <div>
              <span className="eyebrow">Palmarès</span>
              <h2>Quarante ans<br /><span className="ital">de victoires.</span></h2>
            </div>
            <p>
              De la création en 1986 au sacre national Navétane de 2019 — six dates
              qui ont fait l'histoire du club et celle du village.
            </p>
          </div>

          <div className="palm-grid">
            <div className="palm-intro reveal">
              <h3>L'ASC en chiffres</h3>
              <p>
                3 titres régionaux · 1 sacre national · 6 finales atteintes en 40 ans.
                Mais surtout : 280 joueurs formés, dont 14 passés en Ligue 1 sénégalaise.
              </p>
            </div>
            <div className="palm-list">
              {PALMARES.map((p) => (
                <div key={p.year} className="palm-item reveal">
                  <span className="year">{p.year}</span>
                  <span className="title">{p.title}</span>
                  <span className={`trophy${p.gold ? ' gold' : ''}`}>{p.trophy}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ============== CTA ============== */}
      <section className="asc-cta">
        <div className="wrap reveal">
          <span className="eyebrow" style={{ color: 'rgba(250,246,238,.65)' }}>Soutenir l'ASC</span>
          <h3>Venez au stade <span className="ital">samedi.</span></h3>
          <p>
            L'entrée est gratuite, la tribune est petite, l'ambiance est immense.
            La meilleure façon de soutenir l'ASC reste d'y être.
          </p>
          <div className="asc-cta-actions">
            <a href="#matches" className="btn btn-primary">
              <span>Voir les matchs</span>
              <span className="arrow">→</span>
            </a>
            <Link to="/talents" className="btn btn-ghost">
              <span>Talents du village</span>
              <span className="arrow">↗</span>
            </Link>
            <Link to="/actualites" className="btn btn-ghost">
              <span>Actualités</span>
              <span className="arrow">↗</span>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Evenements;
